import {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {useLocation} from 'react-router';
import {AppTheme, applyTheme, storeTheme} from './appTheme';

// The theme of the sticker currently in the store, or null while it has not
// finished loading. Precedence lives here: a loaded sticker always wins; until
// it loads, whatever was applied at boot (the remembered theme) stays.
export function resolvedThemeSelector(state: any): AppTheme | null {
    const stickers = state.stickers.entities.stickers;
    const id = stickers.currentId || stickers.ids[0];
    if (!id || stickers.fetchState?.[id]?.status !== 'succeeded') {
        return null;
    }
    return stickers.byId[id]?.type === 'MEMORIAL' ? 'memorial' : 'base';
}

export function useAppTheme(): void {
    const resolved = useSelector(resolvedThemeSelector);
    const isHome = useLocation().pathname === '/';

    useEffect(() => {
        // Landing on the home screen ends a memorial session.
        const theme = isHome ? 'base' : resolved;
        if (theme) {
            applyTheme(theme);
            storeTheme(theme);
        }
    }, [resolved, isHome]);
}
